<div class=" mt-2">
  <div class="row">
    <div class="">
      <div class="card">
        <div class="header">
          <h2>{{title}}</h2>
        </div>
        <div class="body">
          <apx-chart [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!"
                     [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!" [colors]="areaChartOptions.colors!"
                     [title]="areaChartOptions.title!" [plotOptions]="areaChartOptions.plotOptions!"
                     [stroke]="areaChartOptions.stroke!" [legend]="areaChartOptions.legend!" [grid]="areaChartOptions.grid!"
                     [tooltip]="areaChartOptions.tooltip!" [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
          </div>
      </div>
    </div>
  </div>
</div>
